import "./HiddenDropdown.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { ReactChild, ReactNode, useState } from "react";

export type HiddenDropDownProps = {
  label: string | ReactNode;
  labelActions?: ReactNode;
  isInitOpen?: boolean;
  hasError?: boolean;
  allowOverflow?: boolean;
  type?: "largeLabel" | "filter" | "default";
  setLocalStorage?: Function;
  children: ReactChild;
};

const HiddenDropDown = ({
  label,
  labelActions,
  isInitOpen = false,
  hasError = false,
  allowOverflow = false,
  type = "default",
  setLocalStorage,
  children,
}: HiddenDropDownProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(isInitOpen);
  return (
    <div className="HiddenDropdown">
      <div
        className={classNames(
          `HiddenDropdown__label`,
          `HiddenDropdown__label--${type}`,
          {
            "HiddenDropdown__label--open": isMenuOpen,
          }
        )}
        data-testid="dropdown"
        onClick={() => {
          setLocalStorage && setLocalStorage(!isMenuOpen);
          setIsMenuOpen(!isMenuOpen);
        }}
      >
        <span
          className={classNames("HiddenDropdown__label--container", {
            "HiddenDropdown__label--error": hasError,
          })}
        >
          {label}
          {labelActions && (
            <span
              className="HiddenDropdown__label--actions"
              onClick={(e) => e.stopPropagation()}
            >
              {labelActions}
            </span>
          )}
          {hasError && (
            <FontAwesomeIcon icon="exclamation" color={"var(--red)"} />
          )}
        </span>
        {isMenuOpen ? (
          <FontAwesomeIcon icon="angle-up" />
        ) : (
          <FontAwesomeIcon icon="angle-down" />
        )}
      </div>
      <div
        data-testid="dropdown_container"
        className={classNames([
          "HiddenDropdown__container",
          {
            "HiddenDropdown__container--open": isMenuOpen,
            "HiddenDropdown__container--allowOverflow": allowOverflow,
          },
        ])}
      >
        {children}
      </div>
    </div>
  );
};

export default HiddenDropDown;
